import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { TaxCodeRequest, TaxCodeResponse, TaxCodeUpdateRequest } from 'types/TaxcodeTypes';

import { APIResponse, BUSMAN_TAGS, busmanApiSlice } from './busmanApiSlice';
import { getApiErrorMessage } from './errors';

export const taxCodeEndpoints = busmanApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTaxCodes: builder.query({
      query: () => '/taxcodes/',
      providesTags: [BUSMAN_TAGS.TaxCode],
      transformResponse: (response: APIResponse<TaxCodeResponse[]>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    getTaxCodeById: builder.query({
      query: (id: string) => `/taxcodes/${id}`,
      providesTags: (_result, _err, id) => [{ type: BUSMAN_TAGS.TaxCode, id: id }],
      transformResponse: (response: APIResponse<TaxCodeResponse>) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    addTaxCode: builder.mutation({
      query: (newTaxCode: TaxCodeRequest) => ({
        url: '/taxcodes/',
        method: 'post',
        body: newTaxCode,
      }),
      invalidatesTags: [BUSMAN_TAGS.TaxCode],
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    updateTaxCodeById: builder.mutation({
      query: (updatedTaxCode: TaxCodeUpdateRequest) => ({
        url: `/taxcodes/${updatedTaxCode?.tax_id}`,
        method: 'put',
        body: updatedTaxCode,
      }),
      invalidatesTags: (_result, _err, arg) => [BUSMAN_TAGS.TaxCode, { type: BUSMAN_TAGS.TaxCode, id: arg.tax_id }],
      transformResponse: (response) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),

    deleteTaxCodeById: builder.mutation({
      query: (id: string) => ({
        url: `/taxcodes/${id}`,
        method: 'delete',
      }),
      invalidatesTags: [BUSMAN_TAGS.TaxCode],
      transformResponse: (response) => response.data,
      transformErrorResponse: (response: FetchBaseQueryError) => getApiErrorMessage(response),
    }),
  }),
});

export const { useGetTaxCodesQuery, useGetTaxCodeByIdQuery, useAddTaxCodeMutation, useUpdateTaxCodeByIdMutation } =
  taxCodeEndpoints;
